<template>
    <div>
        <div class="row page-title-header">
            <div class="col-12">
                <div class="page-header">
                    <b-breadcrumb class="m-0">
                        <b-breadcrumb-item :to="{
                            name: 'DashboardHome',
                        }">
                            <i class="fa fa-home"></i>
                        </b-breadcrumb-item>

                        <b-breadcrumb-item :to="{
                            name: 'InvoiceList',
                        }">發票列表
                        </b-breadcrumb-item>
                        <b-breadcrumb-item active>發票明細</b-breadcrumb-item>
                    </b-breadcrumb>
                </div>
            </div>
        </div>

        <b-card>
            <b-overlay :show="showLoading" rounded="sm">
                <div class="row mb-2 align-items-center">
                    <div class="col-12 col-xl-2">
                        <h4 class="font-weight-bold">發票明細</h4>
                    </div>
                </div>
                <div class="row">
                    <div class="col-4">
                        <b-form-group :disabled="isReadOnly">
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="會員名稱">
                                <b-form-input v-model="invoice.customer_name"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="發票號碼">
                                <b-form-input v-model="invoice.invoice_number" maxlength="10"></b-form-input>
                                <b-form-invalid-feedback :state="!v$.invoice.invoice_number.$error">
                                  此欄位為必填
                                </b-form-invalid-feedback>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="發票狀態">
                                <b-form-select v-model="invoice.invoice_status" :options="invoiceStatusOptions">
                                </b-form-select>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="發票開立日期">
                                <b-form-input v-model="invoice.invoice_date"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="發票作廢日期">
                                <b-form-input v-model="invoice.invoice_cancelled_at"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="隨機碼">
                                <b-form-input v-model="invoice.random" maxlength="4"></b-form-input>
                            </b-form-group>
                        </b-form-group>
                    </div>
                    <div class="col-4">
                        <b-form-group :disabled="isReadOnly">
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="金額">
                                <b-form-input v-model="invoice.total_price"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="年份">
                                <b-form-input v-model="invoice.invoice_year"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="期別">
                                <b-form-input v-model="invoice.invoice_period"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="建檔日期">
                                <b-form-input v-model="invoice.created_at"></b-form-input>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="發票種類">
                                <b-form-select v-model="invoice.invoice_type" :options="invoiceTypesOptions">
                                </b-form-select>
                            </b-form-group>
                            <b-form-group label-cols="12" label-cols-lg="2" label-size="m" content-cols="12"
                                content-cols-lg="6" label="發票來源">
                                <b-form-radio-group v-model="invoice.invoice_source" :options="invoiceSourceOptions">
                                </b-form-radio-group>
                            </b-form-group>
                        </b-form-group>
                    </div>
                </div>
                <div class="row mt-4 mb-2 align-items-center">
                    <div class="col-12 col-xl-2">
                        <h4 class="font-weight-bold">發票明細</h4>
                    </div>
                </div>
                <div class="text-right" v-if="!isReadOnly">
                  <b-button
                    class="flex-shrink-0 mb-2 mb-xl-0 ml-2 py-2"
                    variant="primary"
                    @click="addItemHandler"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i>新增明細
                  </b-button>
                </div>
                <b-table striped hover :items="invoice.invoiceItems" :fields="fields">
                  <template #cell(name)="data">
                    <div v-if="isReadOnly">
                      {{ data.item.name }}
                    </div>
                    <div v-else>
                      <b-form-group
                        label-cols="12"
                        label-cols-sm="0"
                        label-size="sm"
                        content-cols="12"
                        content-cols-sm="12">
                        <b-form-input v-model="data.item.name"></b-form-input>
                        <b-form-invalid-feedback 
                          style="margin-bottom: -16px;" 
                          :state="!v$.invoice.invoiceItems.$each.$response.$data[data.index].name.$error"
                        >
                          名稱欄位為必填
                        </b-form-invalid-feedback>
                      </b-form-group>
                    </div>
                  </template>

                  <template #cell(unit_price)="data">
                    <div v-if="isReadOnly">
                      {{ data.item.unit_price }}
                    </div>
                    <div v-else>
                      <b-form-group
                        label-cols="12"
                        label-cols-sm="0"
                        label-size="sm"
                        content-cols="12"
                        content-cols-sm="12">
                        <b-form-input v-model="data.item.unit_price"></b-form-input>
                      </b-form-group>
                    </div>
                  </template>
                  <template #cell(quantity)="data">
                    <div v-if="isReadOnly">
                      {{ data.item.quantity }}
                    </div>
                    <div v-else>
                      <b-form-group
                        label-cols="12"
                        label-cols-sm="0"
                        label-size="sm"
                        content-cols="12"
                        content-cols-sm="12">
                        <b-form-input v-model="data.item.quantity"></b-form-input>
                      </b-form-group>
                    </div>
                  </template>
                  <template #cell(amount)="data">
                    <div v-if="isReadOnly">
                      {{ data.item.amount }}
                    </div>
                    <div v-else>
                      <b-form-group
                        label-cols="12"
                        label-cols-sm="0"
                        label-size="sm"
                        content-cols="12"
                        content-cols-sm="12">
                        <b-form-input v-model="data.item.amount"></b-form-input>
                      </b-form-group>
                    </div>
                  </template>
                  <template #cell(processed_memo)="data">
                    <div v-if="isReadOnly">
                      {{ data.item.processed_memo }}
                    </div>
                    <div v-else>
                      <b-form-group
                        label-cols="12"
                        label-cols-sm="0"
                        label-size="sm"
                        content-cols="12"
                        content-cols-sm="12">
                        <b-form-input v-model="data.item.processed_memo"></b-form-input>
                      </b-form-group>
                    </div>
                  </template>
                  <template #cell(action)="data">
                    <div class="d-flex justify-content-center">
                      <b-button :disabled="isReadOnly" variant="inverse-danger" size="sm" @click="() => deleteInvoiceItem(data.index)">
                        刪除
                      </b-button>
                    </div>
                  </template>
                </b-table>
            <b-form-invalid-feedback :state="!v$.invoice.invoiceItems.$error">
              發票明細至少需要一筆資料
            </b-form-invalid-feedback>
            <div class="d-flex justify-content-center" style="margin-top: 80px">
              
              <!-- 因為發票單號是金谷產生的流水號，我們無法得知開到哪一張，因此停用此功能 -->
              <b-button 
                v-if="isReadOnly && invoice.invoice_source === 'internal' && checkPermission([consts.INVOICE_ISSUE])"
                class="mr-4" 
                variant="primary"
                disabled
                @click="handleIssue"
              >
                開立電子發票
              </b-button>

              <b-button 
                v-if="isReadOnly && invoice.invoice_source === 'internal' && checkPermission([consts.INVOICE_CANCEL])"
                class="mr-4" 
                variant="warning"
                :disabled="invoice.invoice_status !== 'issued'"
                @click="handleCancel"
              >
                作廢電子發票
              </b-button>

              <b-button 
                class="mr-4" 
                variant="outline-danger"
                @click="goToList"
              >
                {{ isReadOnly ? "返回" : "取消" }}
              </b-button>
              <b-overlay
                :show="isSubmmiting"
                rounded
                opacity="0.6"
                spinner-small
                spinner-variant="primary"
                class="d-inline-block"
                v-if="!isReadOnly"
              >
                <b-button variant="success" @click="handleSubmit">
                  {{ isEdit ? "確認修改" : "確認新增" }}
                </b-button>
              </b-overlay>
            </div>
          </b-overlay>
        </b-card>
    </div>
</template>

<script>
import invoiceApi from "../../../apis/invoice";
import { mapState } from "vuex";
import moment from "moment";
import * as consts from "@/consts";
import PermissionChecker from "@/utils/PermissionChecker";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";

export default {
    setup: () => ({ v$: useVuelidate() }),
    validations() {
      return {
        invoice: {
          merchant_id: { required },
          invoice_number: { required },
          invoiceItems: { 
            required,
            $each: helpers.forEach({
              name: {
                required
              }
            })
          }
        }
      };
    },
    data() {
      return {
        consts,
        showLoading: false,
        isSubmmiting: false,
        invoice: {
          merchant_id: null,
          customer_name: '',
          invoice_number: null,
          invoice_status: 'active',
          invoice_date: '',
          invoice_cancelled_at: '',
          random: '',
          total_price: 0,
          invoice_year: '',
          invoice_period: '',
          created_at: '',
          invoice_type: '0',
          invoice_source: 'internal',
          invoiceItems: []
        },
        fields: [
          { key: "row_num", label: "序號"},
          { key: "name", label: "名稱"},
          { key: "unit_price", label: "單價"},
          { key: "quantity", label: "數量"},
          { key: "amount", label: "總價"},
          { key: "processed_memo", label: "處理說明"},
          {key: "action", label: "管理", class: 'narrow-col'},
        ],
        invoiceTypesOptions: [
            { text: '電子發票', value: '0' },
            { text: '捐贈發票', value: '1' },
            { text: '二聯式發票', value: '2' },
            { text: '三聯式發票', value: '3' },
        ],
        invoiceStatusOptions: [
            { text: '已開立', value: 'active' },
            { text: '已作廢', value: 'cancel' },
        ],
        invoiceSourceOptions: [
            { text: '內部', value: 'internal' },
            { text: '外部', value: 'external' },
        ],
      };
    },
    computed: {
        ...mapState("general", {
            organization: (state) => state.organization,
        }),
        merchantId() {
            return this.$route.params.merchantId;
        },
        invoiceId() {
            return this.$route.params.invoiceId;
        },
        isReadOnly() {
          return this.$route.name === "InvoiceDetail"
        },
        isCreate() {
          return this.$route.name === "InvoiceCreate";
        },
        isEdit() {
          return this.$route.name === "InvoiceEdit";
        },
    },
    mounted() {
      var needCheckedPermission = null;
      if (this.isCreate) {
        needCheckedPermission = consts.INVOICE_CREATE;
      }
      else if (this.isEdit) {
        needCheckedPermission = consts.INVOICE_MODIFY;
      }
      else if (this.isReadOnly) {
        needCheckedPermission = consts.INVOICE_LIST_VIEW;
      }

      this.invoice.merchant_id = this.merchantId;
      
      if (!this.checkPermission([needCheckedPermission]) ) {
        this.$swal
          .fire({
            type: "error",
            text: "你沒有權限訪問此頁面",
            confirmButtonColor: "#d33",
          })
          .then(() => {
            this.goToList();
          });
      } else if (this.invoiceId) {
        this.fetchInvoice()
      }
    },
    methods: {
      async fetchInvoice() {
        this.showLoading = true;

        try {
          const { data } = await invoiceApi.getInvoice(this.invoiceId);
          this.invoice = data.data;
          this.invoice.invoice_date = this.formatDate(this.invoice.invoice_date)
          this.invoice.invoice_cancelled_at = this.formatDate(this.invoice.invoice_cancelled_at)
          this.invoice.created_at = this.formatDate(this.invoice.created_at);
          this.invoice.customer_name = data.data?.customer?.name;
        } catch (error) {
          console.error(error);
          alert("取得發票資料錯誤");
        }
        this.showLoading = false;
      },

      formatDate(value) {
          if (value) {
              return moment(String(value)).format("YYYY-MM-DD HH:mm");
          }
      },

      checkPermission(permissions) {
        const checker = new PermissionChecker();
        return checker.check(permissions);
      },

      goToList() {
        this.$router.push({ name: "InvoiceList", query: this.routeQuery });
      },

      addItemHandler() {
        let maxRowNum = Math.max(...this.invoice.invoiceItems.map(item => item.row_num), 0);

        this.invoice.invoiceItems.push({
          id: null,
          name: null,
          unit_price: 0,
          quantity: 0,
          amount: 0,
          processed_memo: '',
          row_num: maxRowNum + 1,
        })
      },

      async handleSubmit() {
        const result = await this.v$.$validate();
        if (!result) return;

        try {
          this.isSubmmiting = true;

          if (this.isEdit) {
            this.handleUpdate();
          } else {
            this.handleCreate();
          }
        } catch (error) {
          const { status, data } = error.response;
          if (status && status === 422 && data.message) {
            const html = Object.values(data.message)
              .map((m) => m[0])
              .join("<br/>");
            this.$swal.fire({
              type: "error",
              html,
            });
          }
        } finally {
          this.isSubmmiting = false;
        }
      },

      async handleUpdate() {
        await invoiceApi.updateInvoice(this.invoiceId, this.invoice);
        this.showSuccessPopup();
      },

      async handleCreate() {
        await invoiceApi.createInvoice(this.invoice);
        this.showSuccessPopup();
      },

      showSuccessPopup() {
        this.$swal
          .fire({
            type: "success",
            title: this.isEdit ? "修改成功" : "新增成功",
            confirmButtonText: "確定",
          })
          .then(() => {
            this.goToList();
          });
      },

      async handleIssue() {
        const result = await this.$swal.fire({
          title: '確認開立電子發票？',
          text: '發票開立後將無法修改',
          showCancelButton: true,
          confirmButtonText: '確認開立',
          cancelButtonText: '取消'
        });

        if (result.value) {
          this.showLoading = true;
          try {
            await invoiceApi.issueInvoice(this.invoiceId);
            this.$swal.fire({
              type: 'success',
              title: '發票開立成功',
              confirmButtonText: '確定'
            });
            await this.fetchInvoice();
          } catch (error) {
            console.error(error);
            const message = error.response?.data?.message || '開立發票失敗';
            this.$swal.fire({
              type: 'error',
              title: '開立失敗',
              text: message,
              confirmButtonText: '確定'
            });
          } finally {
            this.showLoading = false;
          }
        }
      },

      async handleCancel() {
        const result = await this.$swal.fire({
          title: '確認作廢電子發票？',
          text: '發票作廢後將無法恢復',
          showCancelButton: true,
          confirmButtonText: '確認作廢',
          cancelButtonText: '取消'
        });

        if (result.value) {
          this.showLoading = true;
          try {
            await invoiceApi.cancelInvoice(this.invoiceId);
            this.$swal.fire({
              type: 'success',
              title: '發票作廢成功',
              confirmButtonText: '確定'
            });
            await this.fetchInvoice();
          } catch (error) {
            console.error(error);
            const message = error.response?.data?.message || '作廢發票失敗';
            this.$swal.fire({
              type: 'error',
              title: '作廢失敗',
              text: message,
              confirmButtonText: '確定'
            });
          } finally {
            this.showLoading = false;
          }
        }
      },

      deleteInvoiceItem(index) {
        // 確保 index 是有效的，防止出錯
        if (index >= 0 && index < this.invoice.invoiceItems.length) {
          this.invoice.invoiceItems.splice(index, 1);  // 刪除指定索引的元素
        } else {
          console.log("無效的索引:", index);
        }
      }
    },
};
</script>
